// Affichage du WIN4 (2e+3e lot combines) : "4598" -> "45-98" pour bien montrer
// les deux lots. La valeur brute reste "4598" partout ailleurs (saisie, API).
export const fmtWin4 = (w) => (w && String(w).length === 4 ? `${String(w).slice(0, 2)}-${String(w).slice(2)}` : (w || ''));
